export default theme => ({
  select_formcontrol: {
    width: "100%",
  },
  select_label: {
    fontSize: 12,
  },
  reactSelectOptionContainer: {
    backgroundColor: "rgba(0, 0, 0, 0.3) !important",
  },
  reactSelectOption: {
    "&:before": {
      display: "inline-block",
      content: "''",
      width: 0,
      height: 0,
      borderLeft: "7px solid black",
      borderRight: "7px solid transparent",
      borderBottom: "7px solid transparent",
      borderTop: "7px solid transparent",
      marginRight: 5,
    },
  },
});
